module.exports = __webpack_public_path__ + "img/news-08_2x.9ae6be82.png";